import React from 'react';
import Modal from './Modal';
import './HowItWorksModal.css';

interface HowItWorksModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const HowItWorksModal: React.FC<HowItWorksModalProps> = ({ isOpen, onClose }) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="How It Works"
      className="how-it-works-modal"
    >
      <div className="how-it-works-content">
        <p className="how-it-works-intro">
          IMO lets anyone create opinion markets. Back your opinion with SOL — the side 
          with the most SOL when the market ends wins and splits the entire pool.
        </p>

        <div className="how-it-works-steps">
          <p><strong>Step 1:</strong> <span>Pick a market and choose your side</span></p>
          <p><strong>Step 2:</strong> <span>Deposit SOL to back your opinion</span></p>
          <p><strong>Step 3:</strong> <span>Sell anytime to lock in profits or losses</span></p>
        </div>

        <p className="how-it-works-note">
          Early supporters get more tokens per SOL. As more people join, the price increases.
          <span className="how-it-works-fees">Fees: 1.5% poll creator, 1.5% protocol.</span>
        </p>
      </div>
    </Modal>
  );
};

export default HowItWorksModal;
